import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import styled from 'styled-components';

const getText = (options, value) =>
  get(
    options.find(o => o.value === value),
    'text'
  );

const ReadOnlyFieldValueComponent = styled(({ input, className, options }) => {
  const text = useMemo(
    () =>
      !isArray(options)
        ? input.value
        : isArray(input.value)
        ? input.value.map(v => getText(options, v)).join(', ')
        : getText(options, input.value),
    [options, input.value]
  );

  return <div className={className}>{text}</div>;
})`
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  padding: calc(0.67857143em - 1px) 0.67857143em 0.67857143em 0;
  min-height: 2.67em;
`;

ReadOnlyFieldValueComponent.propTypes = {
  input: PropTypes.object.isRequired,
  className: PropTypes.any,
  dateFormat: PropTypes.string,
};

ReadOnlyFieldValueComponent.defaultProps = {
  className: undefined,
  dateFormat: undefined,
};

export default ReadOnlyFieldValueComponent;
